module.exports = "pegasus_template/assets/themelp1/launch/202.png";